import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { Text, Icon, Separator, Cover } from "components";

import css from "styles";
import { colors, sizes, strings } from "assets/constants";
import { sn } from "utils";
import { _goToCustomer } from "routers/helper";

const Cell: React.FC<{ title: string; value: string }> = ({ title, value }) => {
  return (
    <View style={largeBoxStyles.cell}>
      <Text size={"sm"} align="center" weight="bold" color={colors.text.gray}>
        {title}
      </Text>
      <Text
        align="center"
        weight="bold"
        color={value ? colors.text.normal : colors.danger}
      >
        {value ?? "ثبت نشده"}
      </Text>
    </View>
  );
};

const CustomerReportRow: React.FC<{ customer: CustomerT }> = (props) => {
  const { customer } = props;

  if (sn(true, true, false, false)) {
    return (
      <TouchableOpacity
        onPress={() => {
          _goToCustomer({ data: customer });
        }}
        activeOpacity={0.8}
        style={smallBoxStyles.box}
      >
        <View style={{ ...css.rRowCenterAlign }}>
          <Icon type="antDesign" name="user" size={18} />
          <Text style={{ marginRight: 3 }} weight="bold">
            {customer?.name}
          </Text>

          <Cover />
          <Text color={colors.text.gray} size={"sm"} weight="bold">
            {strings?.group}:{" "}
          </Text>
          <Text weight="bold">{customer?.category?.title}</Text>
        </View>
        <View
          style={{
            ...css.rRowCenterAlign,
            backgroundColor: colors.bg.light + "33",
            paddingVertical: 5,
            paddingHorizontal: 4,
            marginVertical: 3,
          }}
        >
          <Text color={colors.text.gray} size={"sm"} weight="bold">
            {strings.familiarity_way}:{" "}
          </Text>
          <Text
            weight="bold"
            size={customer?.frindship ? "md" : "sm"}
            color={customer?.frindship ? colors.text.normal : colors.danger}
          >
            {customer?.frindship?.title ?? "ثبت نشده"}
          </Text>
          <Cover />
          <Text color={colors.text.gray} size={"sm"} weight="bold">
            {strings.city}:{" "}
          </Text>
          <Text
            weight="bold"
            size={customer?.cityName ? "md" : "sm"}
            color={customer?.cityName ? colors.text.normal : colors.danger}
          >
            {customer?.cityName ?? "ثبت نشده"}
          </Text>
        </View>
        <View style={css.rRowCenterAlign}>
          <Text color={colors.text.gray} size={"sm"} weight="bold">
            {strings.creator}:{" "}
          </Text>
          <Text weight="bold">{customer?.seller}</Text>
        </View>
      </TouchableOpacity>
    );
  }

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={() => {
        _goToCustomer({ data: customer });
      }}
      style={largeBoxStyles.box}
    >
      <View style={largeBoxStyles.customerNameContainer}>
        <Icon type="antDesign" name="user" size={30} />
        <Separator axis="y" color={"#eee"} size={"50%"} space={10} />
        <View>
          <Text weight="bold" size={"lg"} align="right">
            {customer?.name}
          </Text>
          <Text weight="extraBold">{customer?.mobile}</Text>
        </View>
      </View>

      <Cell
        title={strings.customer_category}
        value={customer?.category?.title}
      />
      <Cell
        title={strings.familiarity_way}
        value={customer?.frindship?.title}
      />
      <Cell title={strings.city} value={customer?.cityName} />
      <Cell title={strings.creator} value={customer?.seller} />
    </TouchableOpacity>
  );
};

export default CustomerReportRow;

const largeBoxStyles = StyleSheet.create({
  box: {
    padding: 6,
    flexWrap: "wrap",
    marginBottom: 12,
    backgroundColor: "#fff",
    flexDirection: "row-reverse",
    elevation: 10,
    borderRadius: 12,
    ...css.shadow(5),
  },
  cell: {
    flex: 1,
    height: 70,
    borderWidth: 1,
    borderColor: "#f5f5f5",
    margin: 1,
    ...css.centralElements,
    borderRadius: 6,
  },
  customerNameContainer: {
    height: 70,
    flex: 2,
    ...css.wrap,
    ...css.rRowCenterAlign,
    borderWidth: 1,
    borderColor: "#eee",
    borderRadius: 6,
  },
});

const smallBoxStyles = StyleSheet.create({
  box: {
    padding: 6,
    width: "98%",
    borderWidth: 1,
    marginBottom: 12,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.white,
    borderColor: colors.lightBorder,
  },
});
